//import ABI from './edubuksc.json'
import ABI from './updatedEdubukXDC.json'
//XDC test network by aproova sir
//XDC mainnet
export const EdubukConAdd = process.env.REACT_APP_UpdatedContract;
//XDC test net
//export const EdubukConAdd = "0x7c84BB1D231AC10400E58B81C19F875D2E1F8e39";
export const EdubukConABI = ABI.abi;
